import React from "react";
import useIntegrationsApiTeams from "src/scenes/teams/dashboard/use-integrations-api-teams";

const ActiveIntegrationsContextTeams = React.createContext();
ActiveIntegrationsContextTeams.displayName = "ActiveIntegrationsContextTeams";

const ActiveIntegrationsProviderTeams = (props) => {
    const integrationsApi = useIntegrationsApiTeams();
    const [isIntegrated, setIsIntegrated] = React.useState({});
    const [isInvalid, setIsInvalid] = React.useState({});

    React.useEffect(() => {
        let isGitlabIntegrated = "PENDING";
        let isGitlabSelfManagedIntegrated = "PENDING";
        let isGithubIntegrated = "PENDING";
        let isJiraIntegrated = "PENDING";
        let isNotionIntegrated = "PENDING";
        let isSlackIntegrated = "PENDING";
        let isGoogleIntegrated = "PENDING";
        let isMicrosoftIntegrated = "PENDING";

        let gitlabInvalid = false;
        let gitlabSelfManagedInvalid = false;
        let githubInvalid = false;
        let jiraInvalid = false;
        let notionInvalid = false;
        let slackInvalid = false;
        let googleInvalid = false;
        let microsoftInvalid = false;

        if (integrationsApi && integrationsApi.data) {
            isGitlabIntegrated = integrationsApi.data.integrations.find(
                (int) => int.name === "gitlab"
            ).connected;

            isGitlabSelfManagedIntegrated = integrationsApi.data.integrations.find(
                (int) => int.name === "gitlabSelfManaged"
            ).connected;

            isGithubIntegrated = integrationsApi.data.integrations.find(
                (int) => int.name === "github"
            ).connected;

            isJiraIntegrated = integrationsApi.data.integrations.find(
                (int) => int.name === "jira"
            ).connected;

            isNotionIntegrated = integrationsApi.data.integrations.find(
                (int) => int.name === "notion"
            ).connected;

            isSlackIntegrated = integrationsApi.data.integrations.find(
                (int) => int.name === "slack"
            ).connected;

            isGoogleIntegrated = integrationsApi.data.integrations.find(
                (int) => int.name === "google"
            ).connected;

            isMicrosoftIntegrated = integrationsApi.data.integrations.find(
                (int) => int.name === "microsoft"
            ).connected;

            gitlabInvalid = integrationsApi.data.integrations.find(
                (int) => int.name === "gitlab"
            ).invalid;
            gitlabSelfManagedInvalid = integrationsApi.data.integrations.find(
                (int) => int.name === "gitlabSelfManaged"
            ).invalid;
            githubInvalid = integrationsApi.data.integrations.find(
                (int) => int.name === "github"
            ).invalid;
            jiraInvalid = integrationsApi.data.integrations.find(
                (int) => int.name === "jira"
            ).invalid;
            notionInvalid = integrationsApi.data.integrations.find(
                (int) => int.name === "notion"
            ).invalid;
            slackInvalid = integrationsApi.data.integrations.find(
                (int) => int.name === "slack"
            ).invalid;
            googleInvalid = integrationsApi.data.integrations.find(
                (int) => int.name === "google"
            ).invalid;
            microsoftInvalid = integrationsApi.data.integrations.find(
                (int) => int.name === "microsoft"
            ).invalid;
        }

        setIsIntegrated({
            gitlab: isGitlabIntegrated,
            gitlabSelfManaged: isGitlabSelfManagedIntegrated,
            github: isGithubIntegrated,
            jira: isJiraIntegrated,
            notion: isNotionIntegrated,
            slack: isSlackIntegrated,
            google: isGoogleIntegrated,
            microsoft: isMicrosoftIntegrated,
        });

        setIsInvalid({
            gitlab: gitlabInvalid,
            gitlabSelfManaged: gitlabSelfManagedInvalid,
            github: githubInvalid,
            jira: jiraInvalid,
            notion: notionInvalid,
            slack: slackInvalid,
            google: googleInvalid,
            microsoft: microsoftInvalid,
        });
    }, [integrationsApi?.data && JSON.stringify(integrationsApi.data)]);

    const value = React.useMemo(
        () => ({ activeIntegrations: integrationsApi, isIntegrated, isInvalid }),
        [integrationsApi, isIntegrated, isInvalid]
    );

    return <ActiveIntegrationsContextTeams.Provider value={value} {...props} />;
};

const useActiveIntegrationsTeams = () => {
    const context = React.useContext(ActiveIntegrationsContextTeams);
    if (context === undefined) {
        throw new Error(
            `useActiveIntegrationsTeams must be used within a ActiveIntegrationsProviderTeams`
        );
    }
    return context;
};

export { ActiveIntegrationsProviderTeams, useActiveIntegrationsTeams };
